import { phoneNumber } from '@mgo/core/src/validations/person';

export default {
  phoneNumber,
};
